import React, { useState, useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';

import ToastContext from './ToastContext';
import Toast, { IToast, IToastContent } from './Toast';

function generateUEID(): string {
  let first: string | number = (Math.random() * 46656) | 0;
  let second: string | number = (Math.random() * 46656) | 0;

  first = `000${first.toString(36)}`.slice(-3);
  second = `000${second.toString(36)}`.slice(-3);

  return first + second;
}

function withToastProvider(Component: React.FC) {
  function WithToastProvider<T>(props: T) {
    const [bodyElement, setBodyElement] = useState<HTMLElement>();
    const [toasts, setToasts] = useState<IToast[]>([]);
    const add = (content: IToastContent) => {
      const id = generateUEID();

      setToasts([...toasts, { id, content }]);
    };
    const remove = (id: string) => setToasts(toasts.filter((toast) => toast.id !== id));
    const providerValue = useMemo(() => ({ add, remove }), [toasts]);

    useEffect(() => {
      setBodyElement(document.body);
    }, []);

    return (
      <ToastContext.Provider value={providerValue}>
        <Component {...props} />

        {bodyElement &&
          createPortal(
            <div className="toasts-wrapper">
              {toasts.map((toast) => (
                <Toast key={toast.id} remove={() => remove(toast.id)} content={toast.content} />
              ))}
            </div>,
            bodyElement,
          )}
      </ToastContext.Provider>
    );
  }

  return WithToastProvider;
}

export default withToastProvider;
